module.exports = __webpack_public_path__ + "static/media/Tekion_logo.b9504caf.webp";